import type { Editor } from '@tiptap/react';

/**
 * Merges the attrs returned by `update` onto the task item node at `position`
 * with a `tr.setNodeMarkup` transaction, targeting the exact node position so
 * nested task items are updated unambiguously.
 *
 * Returns the node's merged attrs, or `undefined` (without dispatching) when
 * there is no node at `position`.
 */
export const updateTaskItemAttrs = ({
    editor,
    position,
    update,
}: {
    editor: Editor;
    position: number;
    update: (attrs: Record<string, unknown>) => Record<string, unknown>;
}): Record<string, unknown> | undefined => {
    const node = editor.state.doc.nodeAt(position);
    if (!node) return undefined;

    const attrs = { ...node.attrs, ...update(node.attrs) };
    editor.view.dispatch(editor.state.tr.setNodeMarkup(position, undefined, attrs));
    editor.commands.flushPendingUpdate({});

    return attrs;
};
